/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse
 */
export interface DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse
     */
    order_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse
     */
    design_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse
     */
    design_name?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponseFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse {
    return DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponseFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'order_id': !exists(json, 'order_id') ? undefined : json['order_id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'design_id': !exists(json, 'design_id') ? undefined : json['design_id'],
        'design_name': !exists(json, 'design_name') ? undefined : json['design_name'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponseToJSON(value?: DigitizingserviceMelcoDigitizingModelsCopyOrderToAppResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'order_id': value.order_id,
        'product_code': value.product_code,
        'design_id': value.design_id,
        'design_name': value.design_name,
    };
}


